import useRoute from "@components/_hooks/CSRHooks/useRoute";
import dynamic from "next/dynamic";
import Head from "next/head";
import { useEffect } from "react";

const CategoryWrapper = dynamic(() => import("@components/Components/CategoryComponent/CategoryWrapper"))
const Search = dynamic(() => import("../js/Components/Search/Search"))

const exactRoute = 'search'

const route = ({ data, search_term }) => {
    const { products,
    articles,
    term,
    images,
    videos,
    long_term
 } = data;

    const {data: routeData, route, loading, setData, setRoute} = useRoute(data, exactRoute);

    useEffect(() => {
        setData(data);
        setRoute(exactRoute);
    }, [data])

    return (
        <>
            <Head>
                <title>{`Search - ${process.env.brand.brand_name}`}</title>
                <meta name="robots" content="noindex"/>
            </Head>
            <CategoryWrapper
                category={{
                    ...routeData,
                    exactRoute
                }}
            >
                <Search searchData={routeData} />
            </CategoryWrapper>

        </>
    );
};

export async function getServerSideProps({ query, res }) {
    
    const search_term = query.term; //grab the route from url
    // res.setHeader(
    //     'Cache-Control',
    //     'public, s-maxage=43200, stale-while-revalidate=59'
    //   );

    const req = await fetch(
        `${process.env.BASE_API_URL}get-search-results?term=${search_term}`
    ); //find the category data from the url
    const data = await req.json();

    if(data.exception) {
        return {notFound: true}
    }

    return {
        props: {
            //pass props into route
            data,
            search_term,
        },
    };
}

export default route;
